import { insertIf, typeGuard } from '../../../utils';
export const cacheTagTypes = typeGuard(['GENERAL', 'SPECIFIC']);
/**
 * Create a cache tag for RTK-Query.
 */
const createTag = (type, ...keys) => ({
    type: type,
    id: keys
        .filter((x) => x !== undefined)
        .join('_')
        .toLowerCase(),
});
const createTags = (tagType, { chainId, address1, address2, address3 }) => [
    createTag(tagType, chainId),
    ...insertIf(address1, () => [createTag(tagType, chainId, address1)]),
    ...insertIf(address2, () => [
        createTag(tagType, chainId, address2),
        createTag(tagType, chainId, address1, address2),
    ]),
    ...insertIf(address3, () => [
        createTag(tagType, chainId, address3),
        createTag(tagType, chainId, address1, address3),
        createTag(tagType, chainId, address1, address2, address3),
    ]),
].flat();
export const createSpecificTags = (payload) => createTags('SPECIFIC', payload);
export const createMostSpecificTag = (payload) => createTags('SPECIFIC', payload).reverse()[0];
/**
 * Not going more general than the chain for now.
 */
export const createGeneralTags = ({ chainId }) => createTags('GENERAL', { chainId });
//# sourceMappingURL=CacheTagTypes.js.map